import MessagesMainContent from '../hoc/messages-main';
import MessagesList from '../hoc/messages-main-content';
import Message from '../hoc/message';

import ROUTES from '../routes';

const MessagesMain = {
  path: ROUTES.MESSAGES_MAIN,
  element: <MessagesMainContent />,
  children: [
    {
      path: ROUTES.MESSAGES_MAIN_UNREAD,
      element: (
        <MessagesList
          matchPath={ROUTES.MESSAGES_MAIN_UNREAD_MESSAGE}
          path={ROUTES.MESSAGES_MAIN_UNREAD}
        />
      ),
      children: [
        {
          path: ROUTES.MESSAGES_MAIN_UNREAD_MESSAGE,
          element: <Message type="main" messageType="new" />,
        },
      ],
    },
    {
      path: ROUTES.MESSAGES_MAIN_IN_PROGRESS,
      element: (
        <MessagesList
          path={ROUTES.MESSAGES_MAIN_IN_PROGRESS}
          matchPath={ROUTES.MESSAGES_MAIN_IN_PROGRESS_MESSAGE}
        />
      ),
      children: [
        {
          path: ROUTES.MESSAGES_MAIN_IN_PROGRESS_MESSAGE,
          element: <Message type="main" messageType="in-progress" />,
        },
      ],
    },
    {
      path: ROUTES.MESSAGES_MAIN_COMPLETED,
      element: (
        <MessagesList
          path={ROUTES.MESSAGES_MAIN_COMPLETED}
          matchPath={ROUTES.MESSAGES_MAIN_COMPLETED_MESSAGE}
        />
      ),
      children: [
        {
          path: ROUTES.MESSAGES_MAIN_COMPLETED_MESSAGE,
          element: <Message type="main" messageType="completed" />,
        },
      ],
    },
    {
      path: ROUTES.MESSAGES_MAIN_ALL,
      element: (
        <MessagesList
          path={ROUTES.MESSAGES_MAIN_ALL}
          matchPath={ROUTES.MESSAGES_MAIN_ALL_MESSAGE}
        />
      ),
      children: [
        {
          path: ROUTES.MESSAGES_MAIN_ALL_MESSAGE,
          element: <Message type="main" messageType="all" />,
        },
      ],
    },
  ],
};

export default MessagesMain;
